import { useContext } from 'react'
import { useQuery, useMutation } from 'react-query'
import { apiGet, apiPost, apiDelete } from 'api'
import AuthContext from 'context/auth-context'

// Fetch all pinned fields for a dashboard
const fetchPinnedFields = async (token, dashboardId) => {
  const url = `dashboards/${dashboardId}/pinned_fields`
  const data = await apiGet({ url, token })
  return data
}

export const usePinnedFields = ({ dashboardId, options = {} }) => {
  const token = useContext(AuthContext)

  return useQuery(
    ['dashboard-pinned-fields', dashboardId],
    () => fetchPinnedFields(token, dashboardId),
    {
      enabled: !!dashboardId && !!token,
      ...options
    }
  )
}

// Create a pinned field
const createPinnedField = async (token, params) => {
  const url = `dashboards/${params.dashboard_id}/pinned_fields`
  const objectName = 'pinned_field'

  // Extract the params we need for the API
  const apiParams = {
    pinnable_id: params.pinnable_id,
    pinnable_type: params.pinnable_type
  }

  const data = await apiPost({ url, token, objectName, params: apiParams })
  return data
}

export const useCreatePinnedField = ({ options = {} }) => {
  const token = useContext(AuthContext)

  return useMutation(
    (params) => createPinnedField(token, params),
    { ...options }
  )
}

// Delete a pinned field
const deletePinnedField = async (token, dashboardId, pinnedFieldId) => {
  const url = `pinned_fields/${pinnedFieldId}`
  const data = await apiDelete({ url, token })
  return data
}

export const useDeletePinnedField = ({ options = {} }) => {
  const token = useContext(AuthContext)

  return useMutation(
    ({ dashboardId, pinnedFieldId }) => deletePinnedField(token, dashboardId, pinnedFieldId),
    { ...options }
  )
}
